import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import CommonLayout from 'components/CommonLayout';
import React from 'react';
import Body from 'containers/ServicesPage/Body';
import messages from 'containers/SiteMapPage/messages';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

const ServicesPage = () => {
  return (
    <GaLoadHOC
      label="Localiser mes services"
      category={EVENT_CATEGORIES.SERVICES}
    >
      <CommonLayout
        content={<Body />}
        icon={<LocationOnOutlinedIcon />}
        title={messages.others_services}
        fullscreen={true}
      ></CommonLayout>
    </GaLoadHOC>
  );
};
export default ServicesPage;
